<template>
    <div class="ppintuan">
        <div class="brief-bg">
            <div class="brief-bg__word" :style="briefwordstyle">
                <h2 class="fadeInUp">产品中心-拼团</h2>
                <span class="fadeInUp">
                    社交电商时代营销利器，快速扩张，帮您降低库存回笼资金
                </span>
            </div>
            <img src="/site_static/pimg/banner_img.png" alt="" :style="briefimg">
        </div>
        <div class="reflow">
            <div class="page-info">
                <h2 :style="pageh">增加销量加快资金回流</h2>
                <h3 style="text-align: left;margin-top: 22px;" :style="pageh">快速积累人气和流量，帮助您环节库存压力，快速卖货，回笼资金，提升订单成交率</h3>
                <img src="/site_static/pimg/speed-distribution.jpg" alt="">
            </div>
        </div>
        <div class="share">
            <div class="page-info">
                <h2 :style="pageh">社交分享传播，提升商城影响力</h2>
                <h3 style="text-align: left;margin-top: 22px;" :style="pageh">自带10亿微信活跃用户，指数级裂变传播，迅速增加商城曝光率，提高知名度推动商品销量大爆发</h3>
                <img src="/site_static/pimg/social-blob.png" alt="">
            </div>
        </div>
        <div class="wake">
            <div class="page-info">
                <h2 :style="pageh">社交分享传播，提升商城影响力</h2>
                <h3 style="text-align: left;margin-top: 22px;" :style="pageh">自带10亿微信活跃用户，指数级裂变传播，迅速增加商城曝光率，提高知名度推动商品销量大爆发</h3>
                <img src="/site_static/pimg/wake-vip.jpg" alt="">
            </div>
        </div>
        <div class="page-info">
            <h2   :style="pageh">拼团页面展示</h2>
            <div class="lunbo">
                <ul @touchstart="touchstart()" @touchend="touchend($event)" :style="'left:'+ -lunboleft+'rem;'" >
                    <li>
                        <img src="/site_static/pimg/group3.jpg" alt="">
                    </li>
                    <li :class="lunboact[0]">
                        <img src="/site_static/pimg/template4.jpg" alt="">
                    </li>
                    <li :class="lunboact[1]">
                        <img src="/site_static/pimg/group1.jpg" alt="">
                    </li>
                    <li :class="lunboact[2]">
                        <img src="/site_static/pimg/group2.jpg" alt="">
                    </li>
                    <li :class="lunboact[3]">
                        <img src="/site_static/pimg/group3.jpg" alt="">
                    </li>
                    <li :class="lunboact[0]">
                        <img src="/site_static/pimg/template4.jpg" alt="">
                    </li>
                    <li>
                        <img src="/site_static/pimg/template1.jpg" alt="">
                    </li>

                </ul>
            </div>
            <div class="luna">
                <span :class="la[0]"></span>
                <span :class="la[1]"></span>
                <span :class="la[2]"></span>
                <span :class="la[3]"></span>
            </div>
        </div>
        <div class="character">
            <div class="page-info">
                <h2 :style="pageh">微涟 拼团的特色</h2>
                <img src="/site_static/pimg/Assemble-character.jpg" alt="">
            </div>
        </div>
        <div class="painer">
            <div class="page-info">
                <h2 :style="pageh">解决三大拼团活动通痛点</h2>
                <ul>
                    <li>
                        <img src="/site_static/pimg/pain1.jpg" alt="">
                        <span>推广传播难</span>
                    </li>
                    <li>
                        <img src="/site_static/pimg/pain2.jpg" alt="">
                        <span>宣传成本高</span></li>
                    <li>
                        <img src="/site_static/pimg/pain3.jpg" alt="">
                        <span>订单转化少</span>
                    </li>
                </ul>
            </div>

        </div>

        <div class="fooder">
            <div class="logo">
                <img src="../../../assets/phoneimg/nav_logo.png" alt="">
            </div>
            <div class="body">
                <ul>
                    <li>国际顶级域名</li>
                    <li>出版物经营许可证</li>
                    <li>广播电视节目制作经营许可证</li>
                    <li>开户许可证</li>
                    <li>食品经营许可证</li>
                    <li>计算机软件著作权证书</li>
                    <li>网络文化经营许可证</li>
                    <li>营业执照</li>
                    <li>增值电信业务许可证</li>
                </ul>
            </div>
            <div class="last">
                <span>微涟科技有限公司版权所有</span>
                <span>©辽ICP备18009739号</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ppintuan',
        data(){
            return{
                briefwordstyle:{},
                briefimg:{},
                pageh:{},
                lunboleft:14,
                lunboact:['lunact','','',''],
                la:['la','','',''],
                lunindex:0
            }
        },
        created() {
            let self = this
            setTimeout(function () {
                self.briefwordstyle={
                    opacity: 1,
                    bottom: '3rem'
                }
                self.briefimg={
                    opacity: 1,
                    bottom: '1rem'
                }
                self.pageh={
                    opacity: 1,
                    bottom: 0
                }
            },0)
        },
        methods:{
            touchstart(){
                this.startX = event.changedTouches[0].pageX
                this.startY = event.changedTouches[0].pageY
            },
            touchend(event) { // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
                event.preventDefault()
                var moveEndX = event.changedTouches[0].pageX
                var moveEndY = event.changedTouches[0].pageY
                var X = moveEndX - this.startX
                var Y = moveEndY - this.startY
                if (Math.abs(X) > Math.abs(Y) && X > 120) {
                    //左滑-
                    let i = 0
                    let self= this
                    if(this.lunboleft<=14){
                        this.lunboleft=82
                    }
                    let huadong = setInterval(function () {
                        if(i>=17){
                            window.clearInterval(huadong);
                            self.lunboleft+=0.2
                            if (self.lunindex== 0){
                                self.lunindex = self.lunboact.length
                            }
                            self.lunindex--
                            for (var j = 0 ;j<4;j++){
                                self.$set(self.lunboact,j, '');
                                self.$set(self.la,j, '');
                            }
                            self.$set(self.lunboact,self.lunindex, 'lunact');
                            self.$set(self.la,self.lunindex, 'la');
                        }else{
                            i+=0.2
                            self.lunboleft-=0.2
                        }
                    },5)

                } else if (Math.abs(X) > Math.abs(Y) && X < -120) {
                    //右滑+
                    let i = 0
                    let self= this
                    if(this.lunboleft>=82){
                        this.lunboleft=14
                    }
                    let huadong = setInterval(function () {
                        if(i>=17){
                            window.clearInterval(huadong);
                            self.lunboleft-=0.2
                            if (self.lunindex>= self.lunboact.length-1){
                                self.lunindex = 0
                            }else{
                                self.lunindex++
                            }
                            for (var j = 0 ;j<4;j++){
                                self.$set(self.lunboact,j, '');
                                self.$set(self.la,j, '');
                            }
                            self.$set(self.lunboact,self.lunindex, 'lunact');
                            self.$set(self.la,self.lunindex, 'la');
                        }else{
                            i+=0.2
                            self.lunboleft+=0.2
                        }
                    },5)
                }
            }
        }
    }
</script>
<style scoped>
    ul{
        list-style: none;
        padding: 0;
    }
    .ppintuan{
        margin-top: 3rem;
    }
    .brief-bg{
        width: 100%;
        height: 10.9375rem;
        position: relative;
        background: linear-gradient(90deg,#ff5870,#ff8b54);
        overflow: hidden;
    }
    .brief-bg>.brief-bg__word{
        position: absolute;
        width: 11.25rem;
        left: 1.25rem;
        bottom: 0rem;
        color: #fff;
        opacity: 0;
        transition: all .5s;
    }
    .brief-bg>.brief-bg__word>h2{
        line-height: 1.125rem;
        font-weight: 600;
        font-size: 1.125rem;
        color: #fff;
        margin-bottom: 1.25rem;
    }
    .brief-bg>.brief-bg__word>span {
        font-size: .75rem;
        color: hsla(0,0%,100%,.8);
        line-height: 1.3125rem;
    }
    .brief-bg>img{
        width: 8.0625rem;
        position: absolute;
        bottom: 0rem;
        right: 1.25rem;
        opacity: 0;
        transition: all .5s;
    }
    .reflow{
        position: relative;
        width: 100%;
        height: 21.25rem;
        overflow: hidden;
        background-color: #fff;
    }
    .page-info{
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .page-info>h2{
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #5d6494;
        position: relative;
        bottom: -2rem;
        transition: all .5s;
        opacity: 0;
    }
    .page-info>h3{
        width: 18.6875rem;
        margin: auto;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
        position: relative;
        bottom: -2rem;
        transition: all 1s;
    }
    .reflow img{
        display: block;
        margin: 1.5625rem auto;
        width: 17.71875rem;
        height: 10.03125rem;
    }
    .share img{
        display: block;
        margin: 1.5625rem auto;
        width: 12.875rem;
        height: 11.6875rem;
    }
    .share{
        position: relative;
        width: 100%;
        height: 22.5rem;
        overflow: hidden;
        background-color: #fafafa;
    }
    .wake{
        position: relative;
        width: 100%;
        height: 23.5625rem;
        overflow: hidden;
        background-color: #fff;
    }
    .wake img{
        display: block;
        margin: 1.5625rem auto;
        width: 13.90625rem;
    }
    .lunbo{
        width: 100%;
        overflow: hidden;
        position: relative;
        height: 29rem;
        margin-bottom: 4rem;
    }
    .lunbo>ul{
        width: 119rem;
        overflow: visible;
        position: absolute;
        top: 0;
        left: 0;
    }
    .lunbo>ul>li{
        width: 16rem;
        float: left;
        margin: 0 0.5rem;
        opacity: .6;
        transition: opacity .35s;
    }
    .lunact{
        opacity: 1 !important;
    }
    .lunbo>ul>li>img{
        width: 100%;
    }
    .luna{
        height: .21875rem;
        bottom: 0;
        position: absolute;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        margin-bottom: 3rem;
    }
    .luna>span{
        height: 100%;
        width: 1.5rem;
        margin: 0 .375rem;
        border-radius: .1875rem;
        background-color: rgb(221, 221, 221);
    }
    .la{
        background-color: rgb(241, 95, 81) !important;
    }
    .character img{
        display: block;
        margin: 1.875rem auto 2.1875rem;
        width: 19.125rem;
    }
    .character{
        position: relative;
        width: 100%;
        overflow: hidden;
        background-color: #fff;
    }
    .painer{
        position: relative;
        width: 100%;
        overflow: hidden;
        background-color: #fafafa;
        margin: .9375rem 0 2.1875rem;
    }
    .painer ul{
        display: flex;
        margin-top: 1.875rem;
        justify-content: center;
    }
    .painer ul li{
        width: 6.59375rem;
        height: 6.59375rem;
        border-radius: .1875rem;
        overflow: hidden;
        position: relative;
        margin: 0 .28125rem;
    }
    .painer ul li img{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .painer ul li span{
        position: absolute;
        top: 4.625rem;
        left: 0;
        right: 0;
        font-size: .75rem;
        color: #fff;
        text-align: center;
    }

    .fooder{
        width: 100%;
        overflow: hidden;
        background: #1c1c24;
        position: relative;
    }
    .logo{
        width: 20.9375rem;
        margin: auto;
        height: 4.96875rem;
        position: relative;
        margin-left: 2rem;
    }
    .logo>img{
        width: 14.25rem;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: auto;
    }
    .body{
        width: 100%;
        box-sizing: border-box;
        margin: auto;
    }
    .body>ul{
        width: 100%;
        margin-bottom: 1.5rem;
        overflow: hidden;

    }
    .body li{
        margin: 0 1.1875rem 0 0;
        font-size: .75rem;
        color: #888;
        line-height: .75rem;
        width: calc(33% - 1rem);
        float: left;
        margin:  .5rem;
    }
    .last{
        width: 20.9375rem;
        margin: auto;
        height: 4.125rem;
        box-sizing: border-box;
        border-top: 1px solid hsla(0,0%,100%,.1);
        padding: 1.125rem 0 0 0;
        margin-bottom: 3rem;
    }
    .last>span{
        display: block;
        font-size: .625rem;
        color: #3d404d;
        line-height: 1rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/phone/ppro/ppintuan.vue